import { render, staticRenderFns } from "./groupVotingStationsWindow.vue?vue&type=template&id=4f862486"
import script from "./groupVotingStationsWindow.vue?vue&type=script&lang=js"
export * from "./groupVotingStationsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports